
































































































































































































































































































































import { FormFieldDefMap } from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import CrudStepsNavBar from '@/reusable/Mantenedor/CrudStepsNavBar.vue';
import { PasosCrud } from '@/reusable/Mantenedor/mantenedorUtils';
import ContenidoModal from '@/reusable/Modal/ContenidoModal.vue';
import TextField from '@/reusable/Form/TextField.vue';
import { Funcionalidades } from '@/config/funcionalidades';
import config from '@/config/index';
import DatatableSolu from '@/pantallas/SucursalVirtual/Cotizador/datatableSolu.vue';
import { AxiosResponse } from 'axios';
import { MSResponse } from '@/interfaces/MS';
import { CotizadorService } from '@/pantallas/SucursalVirtual/Cotizador/CotizadorService';
import SucursalVirtuallInstance from '@/pantallas/SucursalVirtual/comunes/instances';
import { Validator } from 'vee-validate';
import ValidaRut from '@/config/validaRut';
import { actionsEvent } from '@/setup';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  components: {
    CabeceraModal,
    ModalMantenedor,
    CrudStepsNavBar,
    ContenidoModal,
    TextField,
    FormFieldsContainer,
    DatatableSolu,
  },
})
export default class CotizacionModal extends Vue {
  @Prop({ default: true }) show: boolean;
  @Prop({ default: 'create' }) tipo: string;
  @Prop({ default: '' }) idToEdit: string;
  readonly funcionalidad: Funcionalidades = Funcionalidades.EditarVehiculos;
  respuesta: any;
  dictionaryFormErrors: any = {};
  clientList: any = [];
  solucionesList: any = [];
  solucionesListBackup: any[] = [];
  modalidadList: any = [{ modalidad: 'Arriendo' }, { modalidad: 'Venta' }];
  plazoList: any = [
    { plazo: '12 meses' },
    { plazo: '24 meses' },
    { plazo: '36 meses' },
    { plazo: '48 meses' },
  ];
  tipoEquipoList: any = [];
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  cotizadorService = new CotizadorService();
  vr: ValidaRut = new ValidaRut();
  id_cotizacion: string = '';
  pasoActivoIndex = 1;
  pasos: PasosCrud = {
    requerimiento: {
      accion: 'Nueva Cotización',
      visible: true,
      step: 1,
      title: 'Nueva Cotización',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };
  pasos2: PasosCrud = {
    requerimiento: {
      accion: 'Editar Cotización',
      visible: true,
      step: 1,
      title: 'Editar Cotización',
      icon: 'ballot',
      formState: {
        entity: null,
        validator: null,
        isDirty: false,
      },
    },
  };
  userData: any = {};

  dataSolu: any = [];
  editingSoluId: string | null = null;
  nombreEjecutivo: string = '';
  emailEjecutivo: string = '';
  emailsError: string = '';

  formFields: any = {
    rut: {
      label: 'Rut *',
      id: 'rut',
      value: '',
    },
    razon_social: {
      label: 'Razón Social *',
      id: '',
      value: '',
    },
    nombreContacto: {
      label: 'Nombre de Contactos *',
      id: '',
      value: '',
    },
    emailContacto: {
      label: 'Emails *',
      id: '',
      value: '',
    },
    phoneContacto: {
      label: 'Teléfono *',
      id: '',
      value: '',
    },
    direccion: {
      label: 'Dirección *',
      id: '',
      value: '',
    },
    ejecutivo: {
      label: 'Ejecutivo',
      id: '',
      value: '',
    },
    emailEjecutivo: {
      label: 'Email Ejecutivo',
      id: '',
      value: '',
    },
    condicion_comercial: {
      label: 'Observaciones adicionales',
      id: '',
      value: '',
    },
  };

  formFieldsSoluciones: any = {
    solucion_id: {
      label: 'Solución',
      id: '',
      value: '',
    },
    modalidad: {
      label: 'Modalidad',
      id: '',
      value: '',
    },
    cantidad: {
      label: 'Cantidad',
      id: '',
      value: '',
    },
    plazo: {
      label: 'Plazo',
      id: '',
      value: '',
    },
    venta: {
      label: 'Venta (UF/Unit)',
      id: '',
      value: '',
    },
    servicio: {
      label: 'Servicio (UF/Mes)',
      id: '',
      value: '',
    },
    arriendo: {
      label: 'Arriendo (UF/Mes)',
      id: '',
      value: '',
    },
    instalacion: {
      label: 'Instalación (UF/Unit)',
      id: '',
      value: '',
    },
  };

  msg_variacion: string = '* La variación no puede ser menor a 15% dcto';

  disableModalidad: boolean = false;

  constructor() {
    super();
    actionsEvent.onEditar(this.handleEdit);
    actionsEvent.onEliminar(this.handleDelete);
  }

  @Watch('idToEdit', { immediate: true })
  onEditCotizacion() {
    if (this.idToEdit != '') {
      this.id_cotizacion = this.idToEdit;
    }
  }
  handleEdit(params: ICellRendererParams) {
    this.editarSolu(params.data.id_solucion);
    this.updateSolus();
  }
  handleDelete(params: ICellRendererParams) {
    var self = this;
    let index = this.dataSolu.findIndex(
      (obj: any) => obj.id_solucion === params.data.id_solucion
    );

    if (index !== -1) {
      // Almacena el objeto y luego remuévelo de dataSolu
      let soluToRemove = this.dataSolu[index];
      this.dataSolu.splice(index, 1);
      // Recalcula el total de inversión y servicios
      let totalIndex = this.dataSolu.findIndex(
        (obj: any) => obj.nombre_solucion === 'Total'
      );
      if (totalIndex !== -1) {
        this.dataSolu[totalIndex].total_inversion -=
          soluToRemove.total_inversion;
        this.dataSolu[totalIndex].total_servicio -= soluToRemove.total_servicio;
        this.dataSolu[totalIndex].total_inversion = parseFloat(
          this.dataSolu[totalIndex].total_inversion.toFixed(2)
        );
        this.dataSolu[totalIndex].total_servicio = parseFloat(
          this.dataSolu[totalIndex].total_servicio.toFixed(2)
        );
      }
    }
    self.updateSolus();
  }

  created() {
    let self = this;
    Validator.extend('emailFormat', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || `* ${self.emailsError}`;
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: self.validateEmail(value),
            data: self.validateEmail(value)
              ? undefined
              : { message: `* ${self.emailsError}` },
          });
        });
      },
    });

    Validator.extend('valueVenta', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || self.msg_variacion;
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: self.changeVenta(),
            data: self.changeVenta()
              ? undefined
              : { message: self.msg_variacion },
          });
        });
      },
    });

    Validator.extend('valueServicio', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || self.msg_variacion;
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: self.changeServicio(),
            data: self.changeServicio()
              ? undefined
              : { message: self.msg_variacion },
          });
        });
      },
    });

    Validator.extend('valueArriendo', {
      getMessage(field: any, params: any, data: any) {
        return (data && data.message) || self.msg_variacion;
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: self.changeArriendo(),
            data: self.changeArriendo()
              ? undefined
              : { message: self.msg_variacion },
          });
        });
      },
    });

    this.userData = JSON.parse(localStorage.getItem('user'));
    this.nombreEjecutivo = `${this.userData.nombre} ${this.userData.apellidoPaterno}`;
    this.emailEjecutivo = this.userData.email;
    this.loadClients().finally(() => {
      self.getCotizacion();
    });
    this.loadSoluciones();
  }

  mounted() {
    let self = this;

    this.dictionaryFormErrors = {
      custom: {
        rut: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        razon_social: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo solo debe contener letras y/o espacios.',
        },
        ubicacion: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        apellidoPaterno: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo Paterno solo debe contener letras y/o espacios.',
        },
        apellidoMaterno: {
          max: () => config.errorMensajes.maxLength,
          alpha_spaces: () =>
            '* El campo solo debe contener letras y/o espacios.',
        },
        email: {
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
        },
        direccion: {
          max: () => config.errorMensajes.maxLength,
        },
        telefonoFijo: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        telefonoFijo2: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        telefonoFijo3: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        telefonoFijo4: {
          max: () => config.errorMensajes.maxLength,
          numeric: () => 'El campo debe ser unicamente numérico',
        },
        celular: {
          max: () => config.errorMensajes.maxLength,
          regex: () => config.errorMensajes.regex,
        },
        estado: {
          required: () => config.errorMensajes.textoRequerido,
        },
        fechaNacimiento: {
          mayorDeEdad: () => config.errorMensajes.fechaMayoriaEdad,
          required: () => config.errorMensajes.textoRequerido,
          max: () => config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
    if (this.tipo == 'create') {
      this.formFields.ejecutivo.value = this.nombreEjecutivo;
      this.formFields.emailEjecutivo.value = this.emailEjecutivo;
    }
  }

  async loadClients() {
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.cotizadorService.getClients();
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.clientList = msResponse.clientList;
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
  }

  handleModalidad(value: any) {
    this.selectSolu();
    if (value == 'Venta') {
      this.formFieldsSoluciones.arriendo.value = '';
      this.formFieldsSoluciones.plazo.value = '';
    } else {
      this.formFieldsSoluciones.venta.value = '';
    }
    this.clearValidateCommercialDetail();
  }

  async loadSoluciones() {
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.cotizadorService.getSoluciones();
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.solucionesList = msResponse.productsList;
      this.solucionesListBackup = msResponse.productsList.map((data: any) => ({
        ...data,
      }));
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
  }

  async selectClient(input: string) {
    this.loadingService.showLoading();
    this.$validator.reset({ name: 'rutVal' });
    this.$validator.reset({ name: 'reasonVal' });
    let client;
    if (input == 'rut') {
      if (this.formFields.rut.value == undefined) {
        this.formFields.rut.value = '';
        this.formFields.razon_social.value = '';
        this.loadingService.hideLoading();
        return false;
      }
      client = this.searchValueSelect(
        this.formFields.rut.value.rut_cliente,
        input
      );
      this.formFields.razon_social.value =
        client != '' ? client : this.formFields.razon_social.value;
    } else {
      if (this.formFields.razon_social.value == undefined) {
        this.formFields.rut.value = '';
        this.formFields.razon_social.value = '';
        this.loadingService.hideLoading();
        return false;
      }
      client = this.searchValueSelect(
        this.formFields.razon_social.value.razon_social,
        input
      );
      this.formFields.rut.value =
        client != '' ? client : this.formFields.rut.value;
    }
    if (
      this.formFields.rut.value == null &&
      this.formFields.razon_social.value == null
    ) {
      this.loadingService.hideLoading();
      return false;
    }
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.cotizadorService.getDataContacto(
      this.formFields.rut.value.rut_cliente
    );
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.formFields.phoneContacto.value =
        msResponse.dataContacto.telefono_contacto;
      this.formFields.nombreContacto.value =
        msResponse.dataContacto.nombre_contacto;
      this.formFields.emailContacto.value =
        msResponse.dataContacto.email_contacto;
      this.formFields.direccion.value =
        msResponse.dataContacto.telefono_contacto;
    } else {
      this.formFields.phoneContacto.value = '';
      this.formFields.nombreContacto.value = '';
      this.formFields.emailContacto.value = '';
      this.formFields.direccion.value = '';
      this.$snotify.warning(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.loadingService.hideLoading();
  }

  async validateCommercialDetail(): Promise<number> {
    let validations: string[] = [];
    // Validar el tipo de modalidad
    if (this.formFieldsSoluciones.modalidad.value == '') {
      validations = [
        'soluciones',
        'modalidad',
        'cantidad',
        'plazo',
        'venta',
        'servicio',
        'arriendo',
        'instalacion',
      ];
    } else if (this.formFieldsSoluciones.modalidad.value == 'Venta') {
      validations = [
        'soluciones',
        'modalidad',
        'cantidad',
        'venta',
        'servicio',
        'instalacion',
      ];
    } else {
      validations = [
        'soluciones',
        'modalidad',
        'cantidad',
        'plazo',
        'servicio',
        'arriendo',
        'instalacion',
      ];
    }
    var hasErrors: number = 0;
    for (const val of validations) {
      let validation = await this.$validator.validate(val);
      if (!validation) {
        hasErrors += 1;
      }
    }
    return hasErrors;
  }

  async clearValidateCommercialDetail() {
    let validations: string[] = [
      'soluciones',
      'modalidad',
      'cantidad',
      'plazo',
      'venta',
      'servicio',
      'arriendo',
      'instalacion',
    ];
    for (const val of validations) {
      this.$validator.reset({ name: val });
    }
  }

  async addSolu() {
    let errors: number = await this.validateCommercialDetail();
    if (errors > 0) {
      return;
    }
    let lineSolu: any = {
      id_solucion: this.formFieldsSoluciones.solucion_id.value,
      nombre_solucion: this.searchNameSolu(
        this.formFieldsSoluciones.solucion_id.value
      ),
      modalidad: this.formFieldsSoluciones.modalidad.value,
      cantidad: this.formFieldsSoluciones.cantidad.value,
      servicio: this.formFieldsSoluciones.servicio.value,
      instalacion: this.formFieldsSoluciones.instalacion.value,
    };
    if (this.formFieldsSoluciones.modalidad.value == 'Venta') {
      if (
        (this.formFieldsSoluciones.plazo.value != '' &&
          this.formFieldsSoluciones.plazo.value != null) ||
        (this.formFieldsSoluciones.arriendo.value != '' &&
          this.formFieldsSoluciones.arriendo.value != null)
      ) {
        this.$snotify.error(
          'En modalidad venta no se admiten valores por Arriendo',
          {
            timeout: 3000,
          }
        );
        return false;
      }
      lineSolu.venta = this.formFieldsSoluciones.venta.value;
      lineSolu.arriendo = 0;
      lineSolu.plazo = '';
      lineSolu.total_inversion =
        (parseFloat(lineSolu.venta) + parseFloat(lineSolu.instalacion)) *
        parseFloat(lineSolu.cantidad);
      lineSolu.total_servicio =
        parseFloat(lineSolu.servicio) * parseFloat(lineSolu.cantidad);
    } else {
      if (
        this.formFieldsSoluciones.venta.value != '' &&
        this.formFieldsSoluciones.venta.value != null
      ) {
        this.$snotify.error(
          'En modalidad arriendo no se admiten valores por Venta',
          {
            timeout: 3000,
          }
        );
        return false;
      }
      lineSolu.venta = 0;
      lineSolu.arriendo = this.formFieldsSoluciones.arriendo.value;
      lineSolu.plazo = this.formFieldsSoluciones.plazo.value;
      lineSolu.total_inversion =
        parseFloat(lineSolu.instalacion) * parseFloat(lineSolu.cantidad);
      lineSolu.total_servicio =
        (parseFloat(lineSolu.servicio) + parseFloat(lineSolu.arriendo)) *
        parseFloat(lineSolu.cantidad);
    }
    lineSolu.total_servicio = parseFloat(lineSolu.total_servicio.toFixed(2));
    lineSolu.total_inversion = parseFloat(lineSolu.total_inversion.toFixed(2));
    if (this.dataSolu.length >= 0) {
      let position = this.dataSolu.length - 1;
      this.dataSolu.splice(position, 0, lineSolu);
    } else {
      this.dataSolu.push(lineSolu);
    }
    this.removeSolution(lineSolu.id_solucion);
    this.cleanFormSoluciones();
    this.calculoTotal();
    this.updateSolus();
  }

  removeSolution(id: any) {
    const index = this.solucionesList.findIndex(
      (data: any) => data.id_producto === id
    );
    if (index !== -1) {
      this.solucionesList.splice(index, 1);
    }
  }

  editarSolu(id_solucion: string) {
    let index = this.dataSolu.findIndex(
      (obj: any) => obj.id_solucion === id_solucion
    );

    if (index !== -1) {
      // Almacena el objeto y luego remuévelo de dataSolu
      let soluToEdit = this.dataSolu[index];
      this.dataSolu.splice(index, 1);

      // Establece el valor de cada campo del formulario
      let solution = this.solucionesListBackup.find(
        (data: any) => data.id_producto == soluToEdit.id_solucion
      );
      if (solution) {
        this.solucionesList.push(solution);
      }
      this.formFieldsSoluciones.solucion_id.value = soluToEdit.id_solucion;
      this.formFieldsSoluciones.modalidad.value = soluToEdit.modalidad;
      this.formFieldsSoluciones.cantidad.value = soluToEdit.cantidad;
      this.formFieldsSoluciones.plazo.value = soluToEdit.plazo;
      this.formFieldsSoluciones.venta.value = soluToEdit.venta;
      this.formFieldsSoluciones.arriendo.value = soluToEdit.arriendo;
      this.formFieldsSoluciones.servicio.value = soluToEdit.servicio;
      this.formFieldsSoluciones.instalacion.value = soluToEdit.instalacion;

      // Recalcula el total de inversión y servicios
      let totalIndex = this.dataSolu.findIndex(
        (obj: any) => obj.nombre_solucion === 'Total'
      );
      if (totalIndex !== -1) {
        this.dataSolu[totalIndex].total_inversion -= soluToEdit.total_inversion;
        this.dataSolu[totalIndex].total_servicio -= soluToEdit.total_servicio;
        this.dataSolu[totalIndex].total_inversion = parseFloat(
          this.dataSolu[totalIndex].total_inversion.toFixed(2)
        );
        this.dataSolu[totalIndex].total_servicio = parseFloat(
          this.dataSolu[totalIndex].total_servicio.toFixed(2)
        );
      }
    }
    this.updateSolus();
  }

  searchNameSolu(id: string) {
    let obj = this.solucionesList.find((obj: any) => obj.id_producto == id);
    if (obj) {
      return obj.nombre_producto;
    }
    return '';
  }

  cleanFormSoluciones() {
    for (let key in this.formFieldsSoluciones) {
      if (this.formFieldsSoluciones.hasOwnProperty(key)) {
        this.formFieldsSoluciones[key].value = '';
      }
    }
    this.disableModalidad = false;
    this.clearValidateCommercialDetail();
  }

  async validateIdData(): Promise<number> {
    let validations: string[] = [
      'rutVal',
      'reasonVal',
      'nameContactVal',
      'emailContactVal',
      'telefonoFijo',
      'directionVal',
    ];
    var hasErrors: number = 0;
    for (const val of validations) {
      let validation = await this.$validator.validate(val);
      if (!validation) {
        hasErrors += 1;
      }
    }
    return hasErrors;
  }

  async guardar(cerrar: boolean = true) {
    let errors = await this.validateIdData();
    let listContacto = this.formFields.nombreContacto.value.split(';');
    let listCorreo = this.formFields.emailContacto.value.split(';');
    if (errors > 0) {
      this.$snotify.error('Existen campos sin completar', {
        timeout: 3000,
      });
      return;
    }
    if (listContacto.length != listCorreo.length) {
      this.$snotify.error(
        'Debe ingresar la misma cantidad de Contactos y Correos',
        {
          timeout: 3000,
        }
      );
      return;
    }
    if (this.dataSolu.length == 0) {
      this.$snotify.error(
        'Se debe agregar por lo menos 1 Detalle de Propuesta Comercial',
        {
          timeout: 3000,
        }
      );
      return;
    }
    let self = this;
    this.loadingService.showLoading();
    let body: any = {};
    for (let key in this.formFields) {
      body[key] = this.formFields[key].value;
    }
    body['dataSolucion'] = this.dataSolu;
    body['userId'] = this.userData.id;
    if (
      this.id_cotizacion != '' &&
      this.id_cotizacion != null &&
      this.id_cotizacion != undefined
    ) {
      body['id'] = this.id_cotizacion;
    }
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await self.cotizadorService.saveCotizacion(
      localStorage.getItem('clienteDefecto'),
      body
    );
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.id_cotizacion = msResponse.id_cotizacion;
      this.$snotify.success(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    if (cerrar) {
      this.handleCerrar();
    }
    this.loadingService.hideLoading();
  }

  async enviar() {
    let self = this;
    this.guardar(false).finally(async () => {
      if (
        self.id_cotizacion == '' ||
        self.id_cotizacion == null ||
        self.id_cotizacion == undefined
      ) {
        self.$snotify.error('No se ha enviado la cotización', {
          timeout: 3000,
        });
        return false;
      }
      self.loadingService.showLoading();
      const axiosResponse: AxiosResponse<
        MSResponse<any>
      > = await self.cotizadorService.EnviarCotizador(
        self.id_cotizacion,
        'Enviar',
        localStorage.getItem('clienteDefecto'),
        this.userData.id
      );
      const msResponse: any = axiosResponse.data;
      if (msResponse.CODIGO_RESPUESTA == '1') {
        self.id_cotizacion = msResponse.id_cotizacion;
        self.$snotify.success(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
        self.handleCerrar();
      } else {
        self.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
          timeout: 3000,
        });
      }
      self.loadingService.hideLoading();
    });
  }

  async getCotizacion() {
    if (this.id_cotizacion == '' && this.idToEdit == '') {
      this.loadingService.hideLoading();
      return false;
    }
    this.loadingService.showLoading();
    const axiosResponse: AxiosResponse<
      MSResponse<any>
    > = await this.cotizadorService.getCotizacion(this.id_cotizacion);
    const msResponse: any = axiosResponse.data;
    if (msResponse.CODIGO_RESPUESTA == '1') {
      this.setDataInput(msResponse);
    } else {
      this.$snotify.error(msResponse.MENSAJE_RESPUESTA, {
        timeout: 3000,
      });
    }
    this.loadingService.hideLoading();
  }

  setDataInput(data: any) {
    let self = this;
    const client = this.searchValue(data.rut_cliente);
    this.formFields.rut.value =
      client != '' ? client : data.rut_cliente + '-' + data.dv;
    this.formFields.razon_social.value =
      client != '' ? client : data.razon_social;
    this.formFields.nombreContacto.value = data.nombre_contacto;
    this.formFields.emailContacto.value = data.email_contacto;
    this.formFields.phoneContacto.value = data.telefono_contacto;
    this.formFields.direccion.value = data.direccion_contacto;
    this.formFields.ejecutivo.value = data.ejecutivo;
    this.formFields.emailEjecutivo.value = data.email_ejecutivo;
    this.formFields.condicion_comercial.value = data.observaciones_adicionales;
    this.dataSolu = data.data_json;
    setTimeout(() => {
      self.calculoTotal();
      self.updateSolus();
      self.loadingService.hideLoading();
    }, 1000);
  }

  searchValue(value: string) {
    let obj = this.clientList.find((obj: any) => {
      return obj.rut_cliente.includes(value);
    });
    if (obj) {
      return obj;
    }
    return '';
  }

  searchValueSelect(value: string, field: string) {
    let obj;
    if (field == 'rut') {
      obj = this.clientList.find((obj: any) => {
        return obj.rut_cliente == value;
      });
    } else {
      obj = this.clientList.find((obj: any) => {
        return obj.razon_social == value;
      });
    }
    if (obj) {
      return obj;
    }
    return '';
  }

  calculoTotal() {
    // console.log("dwadadwada")
    let lineTotal: any = {
      id_solucion: '',
      nombre_solucion: 'Total',
      modalidad: '',
      cantidad: '',
      servicio: '',
      instalacion: '',
      plazo: '',
      venta: '',
      arriendo: '',
    };
    let totalInversion = 0.0;
    let totalMes = 0.0;
    for (let obj of this.dataSolu) {
      if (obj.nombre_solucion != 'Total') {
        totalInversion += obj.total_inversion;
        totalMes += obj.total_servicio;
      }
    }
    let index = this.dataSolu.findIndex(
      (obj: any) => obj.nombre_solucion === 'Total'
    );

    if (index === -1) {
      lineTotal.total_inversion = parseFloat(totalInversion.toFixed(2));
      lineTotal.total_servicio = parseFloat(totalMes.toFixed(2));
      // console.log(lineTotal);
      this.dataSolu.push(lineTotal);
    } else {
      this.dataSolu[index].total_inversion = parseFloat(
        totalInversion.toFixed(2)
      );
      this.dataSolu[index].total_servicio = parseFloat(totalMes.toFixed(2));
    }
  }

  selectSolu() {
    let idSolu = this.formFieldsSoluciones.solucion_id.value;
    let obj = this.solucionesList.find((obj: any) => {
      return obj.id_producto == idSolu;
    });
    if (!obj) return false;

    if (obj.permite_arriendo == 'f') {
      this.formFieldsSoluciones.modalidad.value = 'Venta';
      this.disableModalidad = true;
    } else {
      this.disableModalidad = false;
    }

    if (this.formFieldsSoluciones.modalidad.value == '') {
      this.formFieldsSoluciones.venta.value = obj.minimo_venta;
      this.formFieldsSoluciones.arriendo.value = obj.minimo_arriendo;
      this.formFieldsSoluciones.instalacion.value = obj.minimo_instalacion;
      this.formFieldsSoluciones.servicio.value = obj.minimo_servicio;
    } else {
      if (this.formFieldsSoluciones.modalidad.value == 'Venta') {
        this.formFieldsSoluciones.venta.value = obj.minimo_venta;
        this.formFieldsSoluciones.arriendo.value = '';
      } else {
        this.formFieldsSoluciones.arriendo.value = obj.minimo_arriendo;
        this.formFieldsSoluciones.venta.value = '';
      }
      this.formFieldsSoluciones.instalacion.value = obj.minimo_instalacion;
      this.formFieldsSoluciones.servicio.value = obj.minimo_servicio;
    }
  }

  updateSolus() {
    SucursalVirtuallInstance.$emit('loadDataSolu');
  }

  handleCerrar() {
    this.id_cotizacion = '';
    this.idToEdit = '';
    this.$emit('cerrarCrear');
  }
  validaPropuesta() {
    let valida = true;
    if (!this.changeVenta()) {
      valida = false;
    }
    if (!this.changeServicio()) {
      valida = false;
    }
    if (!this.changeArriendo()) {
      valida = false;
    }
    if (!this.changeInstalacion()) {
      valida = false;
    }
    return valida;
  }

  validarPrecio(tipoPrecio: string, valor: number, obj: { [x: string]: any }) {
    const valorActual = obj[`minimo_${tipoPrecio}`];
    return !this.hasChangedByPercentage(valorActual, valor, 15);
    // const rangoMaximo = parseFloat((valorActual * 1.15).toFixed(2));
    // const rangoMinimo = parseFloat((valorActual * 0.85).toFixed(2));
    // // console.log('valorActual '+valorActual, 'rangoMaximo '+rangoMaximo, 'rangoMinimo '+rangoMinimo)
    // if (valor > rangoMaximo || valor < rangoMinimo) {
    //   this.$snotify.warning(
    //     `El valor de ${tipoPrecio} no puede ser mayor o menor al 15%`
    //   );
    //   return false;
    // }
    // return true;
  }
  changeVenta() {
    const idSolu = this.formFieldsSoluciones.solucion_id.value;
    const obj = this.solucionesList.find((obj: any) => {
      return obj.id_producto == idSolu;
    });
    const valorVenta = this.formFieldsSoluciones.venta.value;
    return this.validarPrecio('venta', valorVenta, obj);
  }
  changeServicio() {
    const idSolu = this.formFieldsSoluciones.solucion_id.value;
    const obj = this.solucionesList.find((obj: any) => {
      return obj.id_producto == idSolu;
    });
    const valorServicio = this.formFieldsSoluciones.servicio.value;
    return this.validarPrecio('servicio', valorServicio, obj);
  }
  changeArriendo() {
    const idSolu = this.formFieldsSoluciones.solucion_id.value;
    const obj = this.solucionesList.find((obj: any) => {
      return obj.id_producto == idSolu;
    });
    const valorArriendo = this.formFieldsSoluciones.arriendo.value;
    return this.validarPrecio('arriendo', valorArriendo, obj);
  }
  changeInstalacion() {
    const idSolu = this.formFieldsSoluciones.solucion_id.value;
    const obj = this.solucionesList.find((obj: any) => {
      return obj.id_producto == idSolu;
    });
    const valorInstalacion = this.formFieldsSoluciones.instalacion.value;
    return this.validarPrecio('instalacion', valorInstalacion, obj);
  }

  hasChangedByPercentage(
    originalValue: number,
    newValue: number,
    percentage: number
  ): boolean {
    if (originalValue == 0) return false;
    // const upperLimit = parseFloat((originalValue * (1 + percentage / 100)).toFixed(2));
    const lowerLimit = parseFloat(
      (originalValue * (1 - percentage / 100)).toFixed(2)
    );

    return newValue < lowerLimit;
  }

  validateEmail(emails: string) {
    if (this.formFields.emailContacto.value == '') {
      return false;
    }
    let listaCorreos = emails.split(';');
    for (var correo of listaCorreos) {
      if (
        //eslint-disable-next-line
        !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          correo.trim()
        )
      ) {
        this.emailsError = 'Correo ' + correo + ' no es válido';
        return false;
      }
    }
    return true;
  }
}
